import { Title, Container, Main } from '../../components'
import styles from './styles.module.css'
import MetaTags from 'react-meta-tags'

const Technologies = () => {
  
  return <Main>
    <MetaTags>
      <title>Технологии</title>
      <meta name="description" content="Foodgram - технологический стек проекта." />
      <meta property="og:title" content="Технологии" />
    </MetaTags>
    
    <Container>
      <h1 className={styles.title}>Технологии</h1>
      <div className={styles.content}>
        <div>
          <h2 className={styles.subtitle}>Технологический стек проекта:</h2>
          <div className={styles.text}>
            <ul className={styles.textItem}>
              <li className={styles.textItem}>Python</li>
              <li className={styles.textItem}>Django</li>
              <li className={styles.textItem}>Django REST Framework</li>
              <li className={styles.textItem}>Djoser (токенная авторизация)</li>
              <li className={styles.textItem}>PostgreSQL</li>
              <li className={styles.textItem}>Gunicorn (WSGI-сервер)</li>
              <li className={styles.textItem}>React (и собираемый через Create React App фронтенд)</li>
              <li className={styles.textItem}>React Router (SPA-навигация)</li>
              <li className={styles.textItem}>Docker &amp; Docker Compose</li>
              <li className={styles.textItem}>Caddy (входной прокси, TLS, отдача статики и медиа)</li>
              <li className={styles.textItem}>GitHub Actions (CI/CD)</li>
            </ul>
          </div>
        </div>
      </div>
    </Container>
  </Main>
}

export default Technologies

